module.exports = __webpack_public_path__ + "img/telephone-x.ad4b4dfb.svg";